/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Container, Pagination, Box } from "@mui/material";
import TableHorizontal from "../../components/TableHorizontal";
import api from "../../services/api";
function ListUsers() {
  const [pageState, setPagepageState] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [users, setUsers] = useState([]);
  const columns = [
    "ID",
    "Photo",
    "Username",
    "Name",
    "Email",
    "Role",
    "Status",
    "Actions",
    "Delete",
  ];
  const keys = [
    "id",
    "image",
    "username",
    "name",
    "email",
    "role_name",
    "status_text",
    "action",
    "delete",
  ];
  const fetchData = async (page = 1) => {
    await api.get(`/users?page=${page}&limit=200`).then((res) => {
      setUsers(res.data.items);
      setTotalPages(res.data.total_pages);
    });
  };
  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPagepageState(value);
    fetchData(value);
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <Container maxWidth="xl" sx={{ mt: 2, mb: 4 }}>
      <TableHorizontal
        screen={"users"}
        columns={columns}
        data={users}
        objectKey={keys}
      />
      <Box
        display="flex"
        width={"100%"}
        height={80}
        alignItems="center"
        justifyContent="center"
      >
        <Pagination
          count={totalPages}
          page={pageState}
          onChange={handleChange}
        />
      </Box>
    </Container>
  );
}

export default ListUsers;
